import type { RichTranslateFn, TranslateFn } from '@newo/localization';
import { createContext, type PropsWithChildren, useContext } from 'react';
import type { CreatorRemoteProps } from '@/srcV2/types/creator.mf.ts';

const noop = () => {};
const noopTranslate: TranslateFn = (namespace, key) => {
	return `${namespace}.${key}`;
};
const noopRich: RichTranslateFn = (namespace, key) => {
	return [`${namespace}.${key}`];
};
interface HostContextValue {
	localization: CreatorRemoteProps['localization'];
}

const defaultHostContext: HostContextValue = {
	localization: {
		translate: noopTranslate,
		rich: noopRich,
		language: 'en',
		onChangeLanguage: noop
	}
};

const HostContext = createContext<HostContextValue>(defaultHostContext);

type HostContextProviderProps = PropsWithChildren<{
	value: HostContextValue;
}>;

export function HostContextProvider({
	value,
	children
}: HostContextProviderProps) {
	return <HostContext.Provider value={value}>{children}</HostContext.Provider>;
}

export function useHostContext() {
	return useContext(HostContext);
}

export type { HostContextValue };
